export default class BPAufgebenRequest {
  bestellungId: string
  bezahlart: string
}
